<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Default Basic Forms</h4>
                        <h5 class="card-subtitle"> Please keep your profile information always current in order to help you when you contact us. </h5>
                        <ul class="nav nav-tabs mt-4" role="tablist">
                            <li class="nav-item"> <a class="nav-link active" data-toggle="tab" href="#Personal Info" role="tab"><span class="hidden-sm-up"></span> <span class="hidden-xs-down">Personal Info</span></a> </li>
                            <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#Business Info" role="tab"><span class="hidden-sm-up"></span> <span class="hidden-xs-down">Business Info</span></a> </li>
                            <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#Financial Info" role="tab"><span class="hidden-sm-up"></span> <span class="hidden-xs-down">Financial Info</span></a> </li>
                        </ul>
                    </div>
                    <form class="form-horizontal">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="username">Aadhaar No.</label>
                                        <div class="col-sm-9"><p class="form-control">123456789</p></div>
                                    </div>
                                </div>
                                <div class="col-xs-12 p-b-20">
                                    <button class="btn btn-block btn-acrecx" type="submit">GET Aadhaar Info</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="alert alert-success alert-rounded col-md-12">AADHAAR Details ( Change Not
                                    Allowed Here ,
                                    Update
                                    Aadhaar For Any Changes )
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="username">Name</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="Name"
                                                   id="Name"
                                                   name="Name"
                                                   placeholder="Monalisa Mondal"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('Name')">{{
                                                errors.first('Name') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="dob">Date Of Birth</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="DOB"
                                                   id="dob"
                                                   name="dob"
                                                   placeholder="22/08/1997"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('dob')">{{
                                                errors.first('dob') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="gender">Gender</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="Gender"
                                                   id="gender"
                                                   name="gender"
                                                   placeholder="Female"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('gender')">{{
                                                errors.first('gender') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pin">PIN Code</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="PIN"
                                                   id="pin"
                                                   name="pin"
                                                   placeholder="743503"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('pin')">{{
                                                errors.first('pin') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pa">Postal Address</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="Postal"
                                                   id="pa"
                                                   name="pa"
                                                   placeholder="Ichapur HIT Road Howrah 4"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('pa')">{{
                                                errors.first('pa') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pin">State</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="State"
                                                   id="State"
                                                   name="State"
                                                   placeholder="WestBegal"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('State')">{{
                                                    errors.first('State') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pa">District</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="District"
                                                   id="District"
                                                   name="District"
                                                   placeholder=" Howrah "
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('District')">{{
                                                    errors.first('District') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pin">Ph No ( As registered in aadhaar )</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="ph"
                                                   id="ph"
                                                   name="ph"
                                                   placeholder="6290966338"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('ph')">{{
                                                    errors.first('ph') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pa">Email Id</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="email"
                                                   id="email"
                                                   name="email"
                                                   placeholder="mondalmonalisa312@gmail.com"
                                                   type="text"
                                                   v-validate="'required'|email">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('email')">{{
                                                    errors.first('email') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pin"> Father/Husband Name</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as=" Father/Husband Name"
                                                   id=" Father/Husband Name"
                                                   name=" Father/Husband Name"
                                                   placeholder="Prafulla Mondal"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has(' Father/Husband Name')">{{
                                                    errors.first(' Father/Husband Name') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="pa">Educational Qualification</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="Educational Qualification"
                                                   id="Educational Qualification"
                                                   name="Educational Qualification"
                                                   placeholder="mondalmonalisa312@gmail.com"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('Educational Qualification')">{{
                                                    errors.first('Educational Qualification') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-lg-6">
                                    <div class="form-group row">
                                        <label class="col-sm-3 control-label" for="dob">Caste</label>
                                        <div class="col-sm-9">
                                            <input :class="{'is-invalid': submitted && errors.has(' Name ')}"
                                                   class="form-control"
                                                   data-vv-as="Caste"
                                                   id="Caste"
                                                   name="Caste"
                                                   placeholder="General"
                                                   type="text"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('Caste')">{{
                                                    errors.first('Caste') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        </div>

                    </form>
                </div>
                <!--                <div class="form-group row">-->
                <!--                    <label class="col-sm-3 text-right control-label col-form-label" for="Name">-->
                <!--                        Name-->
                <!--                    </label>-->
                <!--                    <div class="col-sm-6">-->
                <!--                        <input :class="{'is-invalid': submitted && errors.has(' Name ')}"-->
                <!--                               class="form-control"-->
                <!--                               data-vv-as="Name"-->
                <!--                               id="Name"-->
                <!--                               name="Name"-->
                <!--                               placeholder="MONALISA MONDAL"-->
                <!--                               type="text"-->
                <!--                               v-validate="'required'">-->
                <!--                        <div class="invalid-feedback" v-if="submitted && errors.has('Name')">{{-->
                <!--                            errors.first('Name') }}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="form-group row">-->
                <!--                    <label class="col-sm-3 text-right control-label col-form-label" for="Date Of Birth">-->
                <!--                        Date Of Birth-->
                <!--                    </label>-->
                <!--                    <div class="col-sm-6">-->
                <!--                        <input :class="{'is-invalid': submitted && errors.has(' Date Of Birth')}"-->
                <!--                               class="form-control"-->
                <!--                               data-vv-as="Date Of Birth"-->
                <!--                               id="Date Of Birth"-->
                <!--                               name="Name"-->
                <!--                               placeholder="22/08/1997"-->
                <!--                               type="text"-->
                <!--                               v-validate="'required'">-->
                <!--                        <div class="invalid-feedback" v-if="submitted && errors.has('Date Of Birth')">{{-->
                <!--                            errors.first('Date Of Birth') }}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->

                <!--                <div class="form-group row">-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <label>Gender</label>-->

                <!--                        <select-->
                <!--                                class="form-control border-left mb-3"-->
                <!--                                name="state"-->
                <!--                                type="text"-->
                <!--                        >-->
                <!--                            <option value="Male">Male</option>-->
                <!--                            <option value="Female">Female</option>-->
                <!--                        </select>-->
                <!--                    </div>-->
                <!--                </div>-->


                <!--                <div class="form-group row">-->
                <!--                    <label class="col-sm-2 text-right control-label col-form-label" for="Pin Code">-->
                <!--                        Pin Code-->
                <!--                    </label>-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <input :class="{'is-invalid': submitted && errors.has(' Pin Code ')}"-->
                <!--                               class="form-control"-->
                <!--                               data-vv-as="Pin Code"-->
                <!--                               id="Pin Code"-->
                <!--                               name="Pin Code"-->
                <!--                               placeholder="711104"-->
                <!--                               type="text"-->
                <!--                               v-validate="'required'">-->
                <!--                        <div class="invalid-feedback" v-if="submitted && errors.has('Pin Code')">{{-->
                <!--                            errors.first('Pin Code') }}-->
                <!--                        </div>-->
                <!--                    </div>-->

                <!--                    <label class="col-sm-2 text-right control-label col-form-label" for="Postal Address">-->
                <!--                        Postal Address-->
                <!--                    </label>-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <input :class="{'is-invalid': submitted && errors.has('Postal Address')}"-->
                <!--                               class="form-control"-->
                <!--                               id="Postal Address"-->
                <!--                               name="Postal Address"-->
                <!--                               placeholder="Ichapur HIT Road Howrah 4"-->
                <!--                               type="text"-->
                <!--                               v-validate="'required'">-->
                <!--                        <div class="invalid-feedback" v-if="submitted && errors.has('Postal Address')">{{-->
                <!--                            errors.first('Postal Address') }}-->
                <!--                        </div>-->
                <!--                    </div>-->

                <!--                </div>-->

                <!--                <div class="form-group row">-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <label>State</label>-->

                <!--                        <select-->
                <!--                                class="form-control border-left mb-3"-->
                <!--                                name="state"-->
                <!--                                type="text"-->
                <!--                        >-->
                <!--                            <option value="West Bengal">West Bengal</option>-->
                <!--                            <option value="Tripura">Tripura</option>-->
                <!--                            <option value="Rajasthan">Rajasthan</option>-->
                <!--                            <option value="Sikkim">Sikkim</option>-->
                <!--                            <option value="Tamil Nadu">Tamil Nadu</option>-->
                <!--                            <option value="Telangana">Telangana</option>-->
                <!--                        </select>-->
                <!--                    </div>-->

                <!--                    <div class="col-lg-4">-->
                <!--                        <label>District</label>-->

                <!--                        <select-->
                <!--                                class="form-control border-left mb-3"-->
                <!--                                name="state"-->
                <!--                                type="text"-->
                <!--                        >-->
                <!--                            <option value="Howrah">Howrah</option>-->
                <!--                            <option value="Malda">Malda</option>-->
                <!--                        </select>-->
                <!--                    </div>-->

                <!--                </div>-->

                <!--                <div class="form-group row">-->
                <!--                    <label class="col-sm-2 text-right control-label col-form-label" for="Ph No">-->
                <!--                        Ph No ( As registered in aadhaar )-->
                <!--                    </label>-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <input :class="{'is-invalid': submitted && errors.has(' Ph No')}"-->
                <!--                               class="form-control"-->
                <!--                               data-vv-as="Ph No"-->
                <!--                               id="Ph No"-->
                <!--                               name="Ph No"-->
                <!--                               placeholder="6290966338"-->
                <!--                               type="text"-->
                <!--                               v-validate="'required'">-->
                <!--                        <div class="invalid-feedback" v-if="submitted && errors.has('Ph No')">{{-->
                <!--                            errors.first('Ph No') }}-->
                <!--                        </div>-->
                <!--                    </div>-->

                <!--                    <label class="col-sm-2 text-right control-label col-form-label" for="email">-->
                <!--                        email-->
                <!--                    </label>-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <input :class="{'is-invalid': submitted && errors.has('email')}"-->
                <!--                               class="form-control"-->
                <!--                               id="email"-->
                <!--                               name="email"-->
                <!--                               placeholder="mondalmonalisa312@gmail.com"-->
                <!--                               type="text"-->
                <!--                               v-validate="'required'|email">-->
                <!--                        <div class="invalid-feedback" v-if="submitted && errors.has('email')">{{-->
                <!--                            errors.first('email') }}-->
                <!--                        </div>-->
                <!--                    </div>-->

                <!--                </div>-->
                <!--                <hr>-->

                <!--                <div class="form-group row">-->
                <!--                    <label class="col-sm-2 text-right control-label col-form-label" for="Father/Husband Name">-->
                <!--                        Father/Husband Name-->
                <!--                    </label>-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <input :class="{'is-invalid': submitted && errors.has(' Father/Husband Name')}"-->
                <!--                               class="form-control"-->
                <!--                               data-vv-as="Father/Husband Name"-->
                <!--                               id="Father/Husband Name"-->
                <!--                               name="Father/Husband Name"-->
                <!--                               placeholder="Prafulla Mondal"-->
                <!--                               type="text"-->
                <!--                               v-validate="'required'">-->
                <!--                        <div class="invalid-feedback" v-if="submitted && errors.has('Father/Husband Name')">{{-->
                <!--                            errors.first('Father/Husband Name') }}-->
                <!--                        </div>-->
                <!--                    </div>-->


                <!--                    <div class="col-lg-4">-->
                <!--                        <label>Educational Qualification</label>-->

                <!--                        <select-->
                <!--                                class="form-control border-left mb-3"-->
                <!--                                name="Educational Qualification"-->
                <!--                                type="text"-->
                <!--                        >-->
                <!--                            <option value="B-Tech">B-Tech</option>-->
                <!--                            <option value="Primary education">Primary education</option>-->
                <!--                            <option value="Secondary education">Secondary education or high school</option>-->
                <!--                            <option value="GED">GED</option>-->
                <!--                            <option value="Vocational qualification">Vocational qualification</option>-->
                <!--                            <option value="Bachelor's degree">Bachelor's degree</option>-->
                <!--                            <option value="Master's degree">Master's degree</option>-->
                <!--                            <option value="Doctorate or higher">Doctorate or higher</option>-->
                <!--                        </select>-->
                <!--                    </div>-->

                <!--                </div>-->

                <!--                <div class="form-group row">-->
                <!--                    <div class="col-lg-4">-->
                <!--                        <label>Caste</label>-->

                <!--                        <select-->
                <!--                                class="form-control border-left mb-3"-->
                <!--                                name="Caste"-->
                <!--                                type="text"-->
                <!--                        >-->
                <!--                            <option value="GENERAL">GENERAL</option>-->
                <!--                            <option value="SC">SC</option>-->
                <!--                            <option value="ST">ST</option>-->
                <!--                            <option value="OBC">OBC</option>-->
                <!--                            <option value="Other">Other</option>-->
                <!--                        </select>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
        </div>
    </div>


</template>

<script>
    import Label from "../../express/label/Label";

    export default {
        name: "view.vue",
        components: {Label}
    }
</script>

<style scoped>

</style>
